// CollegeSelector.js
import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { ref, get } from "firebase/database";
import { db } from "../../firebase";
import { setCollegeName } from "./userManagement";

const CollegeSelector = ({ value, onChange }) => {
    const [collegeOptions, setCollegeOptions] = useState([]);

    useEffect(() => {
        const collegesRef = ref(db, "colleges");

        get(collegesRef)
            .then((snapshot) => {
                if (snapshot.exists()) {
                    const data = snapshot.val();
                    const collegesArray = Array.isArray(data) ? data : Object.values(data);
                    setCollegeOptions(collegesArray);
                } else {
                    console.log("No college data available");
                }
            })
            .catch((error) => {
                console.error("Error fetching college data:", error);
            });
    }, []);

    return (
        <Autocomplete
            value={value}
            onChange={(event, newValue) => {
                onChange(newValue);
                setCollegeName(newValue);
            }}
            options={collegeOptions}
            renderInput={(params) => (
                <TextField {...params} label="College" variant="outlined" />
            )}
            fullWidth
        />
    );
};

export default CollegeSelector;
